import Counter from './Counter'

const CountdownTimer = ({
  targetDate: [days, hours, minutes, seconds],
  separator,
  hideText,
}) => {
  return (
    <Counter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
      separator={separator}
      hideText={hideText}
    />
  )
}

export default CountdownTimer
